import { render, staticRenderFns } from "./bloodPressureFollowUp.vue?vue&type=template&id=4fe81900&scoped=true"
import script from "./bloodPressureFollowUp.vue?vue&type=script&lang=js"
export * from "./bloodPressureFollowUp.vue?vue&type=script&lang=js"
import style0 from "./bloodPressureFollowUp.vue?vue&type=style&index=0&id=4fe81900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe81900",
  null
  
)

export default component.exports